import type { TextFieldProps } from '@mui/material';
import { InputAdornment, TextField } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import React from 'react';
import { SearchIcon } from '../../../../icons';

type SearchInputProps = TextFieldProps & {
  showLabel?: boolean;
};

export const SearchInput: React.FC<SearchInputProps> = ({ showLabel = true, ...props }) => {
  return (
    <TextField
      size="small"
      label={showLabel ? 'Search' : undefined}
      placeholder="Name, email, etc..."
      {...props}
      sx={{
        paddingBottom: 0,
        width: '300px',
        '& .css-1ssscdh-MuiInputBase-input-MuiFilledInput-input': {
          paddingBottom: '5px',
        },
        ...props.sx,
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                color={blueGrey[400]}
                style={{
                  transform: 'scale(0.8)',
                }}
              />
            </InputAdornment>
          ),
          ...props.slotProps?.input as object,
        }
      }}
    />
  );
};
